import { Controller } from "@hotwired/stimulus";

// One FAQ accordion item on a Solutions landing page. Server-rendered, closed by default; the
// answer is already in the DOM (good for SEO/no-JS), just hidden — no fetch, no empty state.
export default class extends Controller {
  static targets = ["answer", "icon"];

  toggle() {
    this.answerTarget.classList.toggle("hidden");
    this.iconTarget.classList.toggle("rotate-45");
  }
}
